export const CURRENCY_PILL_CLICK_HTML_ID = "currency-pill-click";
export const CURRENCY_PILL_CLICK_NAME = "currency-pill";

export const CURRENCY_OPTION_CLICK_HTML_ID = "currency-option-click";
export const CURRENCY_OPTION_CLICK_NAME = "currency-option";

export const MINI_BANNER_DISMISS_HTML_ID = "mini-banner-dismiss-multi-click";
export const MINI_BANNER_DISMISS_NAME = "mini-banner-multi-dismiss";
export const MINI_BANNER_DISMISS_TEXT = "close";

/** Tagular `location` for Choose Your Track currency surfaces. */
export const CYT_CURRENCY_TRACKING_LOCATION = "single-course-detail-page / cyt";
